import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { Chip, Text, theme, Spacing } from '@dls/web';
import { forwardRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import InfiniteScrollDropdownInput from '../InfiniteScrollDropdownInput/InfiniteScrollDropdownInput.js';
import '../MultiSelectInput/MultiSelectInput.js';
import { MultiSelectAction } from '../MultiSelectInput/types.js';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
const InfiniteScrollMultiSelectInput = forwardRef((_a, ref) => {
  var _b = _a,
    {
      selectedLabel,
      noSelectionText,
      defaultValue,
      value,
      items,
      onChange,
      onSearch,
      isSelectedItemValid = () => true,
      hint,
      isShowSelectedItemValue,
      valueAll = "All"
    } = _b,
    props = __objRest(_b, ["selectedLabel", "noSelectionText", "defaultValue", "value", "items", "onChange", "onSearch", "isSelectedItemValid", "hint", "isShowSelectedItemValue", "valueAll"]);
  const [selectedValue, setSelectValue] = useState(defaultValue || []);
  useEffect(() => {
    if (!defaultValue && value) {
      setSelectValue(value);
    }
  }, [value, defaultValue]);
  const getItemsByValues = val => {
    return items.filter(i => val.includes(i.value));
  };
  const handleDeleteChip = item => {
    const updatedVal = selectedValue.filter(val => val !== item);
    setSelectValue(updatedVal);
    if (onChange) {
      onChange(updatedVal, {
        selectedItems: getItemsByValues(updatedVal),
        item: getItemsByValues([item])[0],
        action: MultiSelectAction.DELETE
      });
    }
  };
  const handleDropdownChange = async item => {
    let isValid = await isSelectedItemValid(item);
    if (isValid) {
      let updatedValue = [...selectedValue];
      updatedValue.push(item.value);
      if (updatedValue.length > 1) {
        if (item.value !== valueAll && updatedValue.includes(valueAll)) {
          updatedValue = updatedValue.filter(value2 => value2 !== valueAll);
        }
        if (item.value === valueAll) {
          updatedValue = updatedValue.filter(value2 => value2 === valueAll);
        }
      }
      setSelectValue(updatedValue);
      if (onChange) {
        onChange(updatedValue, {
          selectedItems: getItemsByValues(updatedValue),
          item,
          action: MultiSelectAction.ADD
        });
      }
    }
  };
  const findNameByValue = val => {
    var _a2;
    return ((_a2 = items.find(i => i.value === val)) == null ? void 0 : _a2.text) || val;
  };
  const updatedItems = items.filter(i => !selectedValue.includes(i.value));
  const selectedLabelElement = /* @__PURE__ */jsx(Spacing, {
    top: 1,
    bottom: 1,
    children: /* @__PURE__ */jsx(Text, {
      type: "boldBody",
      children: selectedLabel
    })
  });
  const handleSearch = value2 => {
    if (onSearch && value2) {
      onSearch(value2);
    }
  };
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(InfiniteScrollDropdownInput, __spreadProps(__spreadValues({}, props), {
      items: updatedItems,
      onChange: handleDropdownChange,
      onSearch: handleSearch,
      ref
    }), JSON.stringify(selectedValue)), hint, selectedValue.length ? /* @__PURE__ */jsxs(Fragment, {
      children: [selectedLabelElement, /* @__PURE__ */jsx(SCChipWrapper, {
        children: selectedValue.map((item, i) => /* @__PURE__ */jsxs(Chip, {
          variant: "outline",
          children: [/* @__PURE__ */jsx(Chip.Text, {
            children: isShowSelectedItemValue ? item : findNameByValue(item)
          }), /* @__PURE__ */jsx(Chip.CloseButton, {
            onClick: () => handleDeleteChip(item)
          })]
        }, i))
      })]
    }) : noSelectionText ? /* @__PURE__ */jsxs(Fragment, {
      children: [selectedLabelElement, /* @__PURE__ */jsx(Text, {
        type: "body",
        color: theme.main.colours.tertiary.l3,
        children: noSelectionText
      })]
    }) : null]
  });
});
const SCChipWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: -8px;\n"])));
export { InfiniteScrollMultiSelectInput as default };